import { Injectable } from '@angular/core';
import { Placement } from '@floating-ui/dom';

import { KpiDetailRow } from '@core/models/kpi.model';

import { AnchoredPopupState } from '@shared/services/anchored-popup/anchored-popup-state';

export interface KpiDetailCardData {
  /** Translated by the outlet, so an open card follows a language switch. */
  labelKey: string;
  rows: readonly KpiDetailRow[];
  placement: Placement;
}

/** Root singleton: one KPI detail card open at a time, app-wide. */
@Injectable({ providedIn: 'root' })
export class KpiDetailPopupService extends AnchoredPopupState<KpiDetailCardData> {
  /** Opens the card on `anchorEl`, or closes it when that anchor's card is already open. */
  toggle(anchorEl: HTMLElement, data: KpiDetailCardData): void {
    if (this.isOpenFor(anchorEl)) {
      this.close();
      return;
    }
    this.open(anchorEl, data);
  }
}
